module.exports = __webpack_public_path__ + "img/uranus.a0c5147f.svg";